import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutDirective } from './page-layout.directive';
import { PageLayoutHeaderDirective } from './page-layout-header.directive';
import { PageLayoutContentDirective } from './page-layout-content.directive';
import { PageLayoutContentWidthDirective } from './page-layout-content-width.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [PageLayoutDirective, PageLayoutHeaderDirective, PageLayoutContentDirective, PageLayoutContentWidthDirective],
  exports: [PageLayoutDirective, PageLayoutHeaderDirective, PageLayoutContentDirective, PageLayoutContentWidthDirective]
})
export class PageLayoutModule {
}
